import type { Key } from "./en";
import catalogAr from "./catalog.ar";
import inventoryAr from "./inventory.ar";
import customersAr from "./customers.ar";
import taxAr from "./tax.ar";
import discountsAr from "./discounts.ar";
import shippingAr from "./shipping.ar";
import checkoutAr from "./checkout.ar";
import themesAr from "./themes.ar";
import contentAr from "./content.ar";
import domainsAr from "./domains.ar";
import searchAr from "./search.ar";
import codeAr from "./code.ar";
import veAr from "./ve.ar";
import aiAr from "./ai.ar";
import locAr from "./loc.ar";
import redesignAr from "./redesign.ar";
import ordersAr from "./orders.ar";
import paymentsAr from "./payments.ar";
import couriersAr from "./couriers.ar";
import invoicesAr from "./invoices.ar";
import billingAr from "./billing.ar";
import featuresAr from "./features.ar";
import whatsappAr from "./whatsapp.ar";
import engageAr from "./engage.ar";
import analyticsAr from "./analytics.ar";
import marketingAr from "./marketing.ar";
import giftCardsAr from "./giftcards.ar";
import appsAr from "./apps.ar";
import platformAr from "./platform.ar";
import sampleAr from "./sample.ar";
import overviewAr from "./overview.ar";

const ar: Record<Key, string> = {
  ...catalogAr,
  ...inventoryAr,
  ...customersAr,
  ...taxAr,
  ...discountsAr,
  ...shippingAr,
  ...checkoutAr,
  ...paymentsAr,
  ...couriersAr,
  ...invoicesAr,
  ...billingAr,
  ...featuresAr,
  ...whatsappAr,
  ...appsAr,
  ...platformAr,
  ...sampleAr,
  ...overviewAr,
  ...engageAr,
  ...analyticsAr,
  ...marketingAr,
  ...giftCardsAr,
  ...ordersAr,
  ...themesAr,
  ...contentAr,
  ...domainsAr,
  ...searchAr,
  ...codeAr,
  ...veAr,
  ...aiAr,
  ...locAr,
  ...redesignAr,
  "app.name": "سوقنا",
  "common.save": "حفظ",
  "common.discard": "تجاهل",
  "common.cancel": "إلغاء",
  "common.continue": "متابعة",
  "common.leave_title": "مغادرة هذه الصفحة؟",
  "common.leave": "مغادرة الصفحة",
  "security.stepup_title": "أكّد هويتك",
  "security.stepup_body": "يتطلب هذا الإجراء تسجيل دخول حديثًا مع التحقق بخطوتين. ستسجّل الدخول مجددًا ثم تعود إلى هنا مباشرة.",
  "security.stepup_action": "تسجيل الدخول مجددًا",
  "security.mfa_title": "فعّل التحقق بخطوتين",
  "security.mfa_body": "لحماية متجرك، لا يتوفر هذا الإجراء إلا بعد تفعيل التحقق بخطوتين في حسابك.",
  "security.mfa_action": "فتح إعدادات أمان الحساب",
  "common.back": "رجوع",
  "common.loading": "جارٍ التحميل…",
  "common.retry": "أعد المحاولة",
  "common.error": "حدث خطأ ما.",
  "common.saved": "تم الحفظ",
  "common.delete": "حذف",
  "common.remove": "إزالة",
  "common.search": "بحث",
  "common.none": "لا شيء",
  "common.unsaved": "تغييرات غير محفوظة",
  "common.leave_confirm": "لديك تغييرات غير محفوظة. هل تريد مغادرة الصفحة؟",
  "common.coming_soon": "قريبًا",
  "common.optional": "اختياري",
  "common.copy": "نسخ",
  "common.language": "اللغة",

  "user.account": "إعدادات الحساب",
  "user.logout": "تسجيل الخروج",
  "user.stores": "كل المتاجر",

  "chooser.title": "متاجرك",
  "chooser.search": "ابحث في المتاجر",
  "chooser.create": "إنشاء متجر",
  "chooser.empty_title": "ليس لديك أي متجر بعد",
  "chooser.empty_body": "أنشئ متجرك الأول وابدأ البيع. يستغرق الأمر دقيقة تقريبًا.",
  "chooser.role.owner": "المالك",
  "chooser.role.staff": "موظف",
  "chooser.role.collaborator": "متعاون",
  "chooser.development": "قيد التطوير",
  "chooser.partner_dashboard": "لوحة الشريك",
  "chooser.last_opened": "فُتح {when}",
  "chooser.load_more": "عرض المزيد",

  "onboarding.title": "أخبرنا عنك",
  "onboarding.subtitle": "يساعدنا هذا في تجهيز كل شيء لك.",
  "onboarding.type": "أنضم بصفتي",
  "onboarding.merchant": "تاجرًا",
  "onboarding.merchant_hint": "أريد البيع عبر الإنترنت",
  "onboarding.partner": "شريكًا",
  "onboarding.partner_hint": "أبني متاجر لعملائي",
  "onboarding.name": "اسمك",
  "onboarding.country": "الدولة",
  "onboarding.phone": "رقم الهاتف",
  "onboarding.selling_now": "هل تبيع حاليًا؟",
  "onboarding.yes": "نعم",
  "onboarding.no": "ليس بعد",
  "onboarding.industry": "ماذا تبيع؟",
  "onboarding.company": "اسم الشركة",
  "onboarding.website": "الموقع الإلكتروني",
  "onboarding.services": "الخدمات التي تقدمها",
  "onboarding.service.theme_development": "تطوير القوالب",
  "onboarding.service.store_setup": "إعداد المتاجر",
  "onboarding.service.marketing": "التسويق",
  "onboarding.service.integrations": "التكاملات",
  "onboarding.agreement": "أوافق على اتفاقية برنامج الشركاء",

  "create.title": "أنشئ متجرك",
  "create.step": "الخطوة {n} من {total}",
  "create.name": "اسم المتجر",
  "create.name_hint": "يمكنك تغييره لاحقًا.",
  "create.country": "أين يقع نشاطك التجاري؟",
  "create.currency": "عملة المتجر",
  "create.currency_hint": "تُعرض الأسعار بهذه العملة، ولا يمكن تغييرها بعد أول طلب.",
  "create.languages": "لغات المتجر",
  "create.look": "اختر لونًا",
  "create.look_hint": "يُستخدم في واجهة متجرك ورسائل البريد. القوالب لاحقًا.",
  "create.demo": "أضف منتجات تجريبية لأرى شكل المتجر",
  "create.submit": "إنشاء المتجر",
  "create.provisioning": "جارٍ تجهيز {name}",
  "create.provisioning_hint": "يستغرق هذا عادةً بضع ثوانٍ.",
  "create.step.domain": "حجز عنوان متجرك",
  "create.step.subscription": "بدء الفترة التجريبية المجانية",
  "create.step.activate": "فتح متجرك",
  "create.step.other": "التجهيز",
  "create.failed_step": "إعادة المحاولة…",
  "create.ready": "متجرك جاهز",
  "create.open": "انتقل إلى متجرك",

  "nav.collections": "المجموعات",
  "settings.custom_data": "الحقول المخصصة",
  "settings.custom_data_hint": "الحقول المخصصة وأنواع المحتوى",
  "nav.home": "نظرة عامة",
  "nav.orders": "الطلبات",
  "nav.products": "المنتجات",
  "nav.customers": "العملاء",
  "nav.content": "المحتوى",
  "nav.analytics": "التحليلات",
  "nav.marketing": "الحملات",
  "nav.discounts": "الخصومات",
  "nav.online_store": "واجهة المتجر",
  "nav.settings": "الإعدادات",
  "nav.view_store": "عرض المتجر",
  "nav.menu": "القائمة",

  "bell.title": "الإشعارات",
  "bell.empty": "لا توجد إشعارات جديدة.",
  "bell.mark_all": "تعليم الكل كمقروء",

  "trial.banner": "تنتهي فترتك التجريبية المجانية خلال {days} أيام.",
  "trial.banner_today": "تنتهي فترتك التجريبية المجانية اليوم.",
  "trial.banner_ended": "انتهت فترتك التجريبية المجانية.",
  "trial.choose_plan": "اختر خطة",
  "dev.banner": "هذا متجر قيد التطوير. انقله إلى عميلك لإطلاقه.",

  "home.greeting": "مرحبًا، {name}",
  "home.guide": "جهّز متجرك",
  "home.guide_progress": "اكتملت {done} من {total} مهام",
  "home.guide_dismiss": "إخفاء الدليل",
  "home.guide_show": "عرض دليل الإعداد",
  "home.guide.add_product": "أضف منتجك الأول",
  "home.guide.customize_theme": "خصّص واجهة متجرك",
  "home.guide.add_domain": "أضف نطاقًا خاصًا",
  "home.guide.setup_payments": "إعداد المدفوعات",
  "home.guide.setup_shipping": "إعداد الشحن",
  "home.guide.review_policies": "راجع سياسات متجرك",
  "home.guide.test_order": "أنشئ طلبًا تجريبيًا",
  "home.guide.launch": "أطلق متجرك",
  "home.storefront": "واجهة متجرك",
  "home.password_protected": "محمي بكلمة مرور حتى الإطلاق",
  "home.kpis_soon": "ستظهر المبيعات والطلبات والزيارات هنا بعد أن تبدأ البيع.",

  "launch.title": "الإطلاق",
  "launch.ready": "كل شيء جاهز. الإطلاق يزيل كلمة مرور واجهة المتجر.",
  "launch.blocked": "قبل أن تتمكن من الإطلاق:",
  "launch.button": "إطلاق المتجر",
  "launch.blocker.development_store": "تُطلق متاجر التطوير بعد نقلها إلى العميل.",
  "launch.blocker.already_launched": "متجرك يعمل بالفعل.",
  "launch.blocker.plan_required": "اختر خطة مدفوعة.",
  "launch.blocker.email_verified": "أكّد بريدك الإلكتروني.",
  "launch.blocker.store_details": "أضف الاسم القانوني للنشاط وبريد التواصل.",
  "launch.blocker.payments": "أعدّ وسيلة دفع.",
  "launch.blocker.shipping": "أعدّ الشحن.",
  "launch.blocker.policies": "أضف سياسات متجرك.",
  "launch.blocker.payments_unavailable": "إعداد المدفوعات غير متاح بعد.",
  "launch.blocker.shipping_unavailable": "إعداد الشحن غير متاح بعد.",
  "launch.blocker.policies_unavailable": "إعداد السياسات غير متاح بعد.",

  "settings.title": "الإعدادات",
  "settings.general": "ملف المتجر",
  "settings.general_hint": "بيانات المتجر والتواصل والتنسيقات",
  "settings.plan": "الاشتراك",
  "settings.plan_hint": "خطتك وفترتك التجريبية",
  "settings.users": "الفريق والأدوار",
  "settings.users_hint": "الموظفون والأدوار والمتعاونون",
  "settings.notifications": "الإشعارات",
  "settings.notifications_hint": "الرسائل المرسلة إليك وإلى عملائك",
  "settings.files": "الملفات",
  "settings.files_hint": "الصور والفيديو والمستندات",
  "settings.activity": "سجل النشاط",
  "settings.activity_hint": "من غيّر ماذا ومتى",
  "settings.status": "حالة المتجر",
  "settings.status_hint": "الإطلاق والنقل",
  "settings.other": "المناطق والعملات وغيرها قادمة في الإصدارات اللاحقة.",

  "general.details": "بيانات المتجر",
  "general.name": "اسم المتجر",
  "general.legal_name": "الاسم القانوني للنشاط",
  "general.tax_no": "الرقم الضريبي",
  "general.contact_email": "بريد التواصل",
  "general.sender_name": "اسم المرسل",
  "general.phone": "هاتف الدعم",
  "general.formats": "المعايير والتنسيقات",
  "general.timezone": "المنطقة الزمنية",
  "general.unit_system": "نظام الوحدات",
  "general.metric": "متري",
  "general.imperial": "إمبراطوري",
  "general.weight_unit": "وحدة الوزن الافتراضية",
  "general.currency": "عملة المتجر",
  "general.order_ids": "رقم الطلب",
  "general.prefix": "بادئة",
  "general.suffix": "لاحقة",
  "general.conflict": "غيّر شخص آخر هذه الإعدادات. أعد التحميل لرؤية التغييرات.",

  "plan.current": "الخطة الحالية",
  "plan.trial_until": "فترة تجريبية مجانية حتى {date}",
  "plan.development": "متجر تطوير: مجاني أثناء البناء",
  "plan.per_month": "{price} شهريًا",
  "plan.staff": "{n} حسابات موظفين",
  "plan.storage": "{n} غيغابايت للملفات",
  "plan.enterprise": "المؤسسات",
  "plan.enterprise_price": "تسعير مخصص",
  "plan.enterprise_body": "حدود وأسعار ودعم مصممة للعلامات ذات المبيعات الكبيرة والمجموعات.",
  "plan.enterprise_cta": "اطلب عرض سعر",
  "plan.paid_soon": "الخطط المدفوعة والفوترة قريبًا. يستمر متجرك بالعمل خلال الفترة التجريبية.",

  "users.owner": "مالك المتجر",
  "users.staff": "الموظفون",
  "users.invite": "إضافة موظف",
  "users.invite_title": "إضافة موظف",
  "users.email": "البريد الإلكتروني",
  "users.role": "الدور",
  "users.pending": "دعوات معلقة",
  "users.expires": "تنتهي {date}",
  "users.revoke": "إلغاء",
  "users.remove_confirm": "إزالة {name}؟ سيفقد الوصول فورًا.",
  "users.collaborators": "المتعاونون",
  "users.requests": "طلبات التعاون",
  "users.approve": "موافقة",
  "users.decline": "رفض",
  "users.request_from": "{partner} يطلب الوصول",
  "users.mfa": "التحقق بخطوتين مفعّل",
  "users.no_mfa": "التحقق بخطوتين غير مفعّل",
  "users.transfer": "النقل إلى العميل",
  "users.transfer_hint": "أرسل متجر التطوير هذا إلى عميلك. سيصبح المالك وتبدأ فترته التجريبية.",
  "users.transfer_email": "بريد العميل",
  "users.transfer_keep": "الاحتفاظ بصلاحية المتعاون بعد النقل",
  "users.transfer_sent": "أُرسل طلب النقل.",
  "export.store_title": "تصدير بيانات المتجر",
  "export.store_hint": "نزّل كل ما في متجرك في ملف zip واحد: المنتجات والعملاء والطلبات والمحتوى والإعدادات وسجل النشاط، بصيغتي JSON وCSV. لا تُضمَّن كلمات المرور ورموز الوصول ومفاتيح الدفع.",
  "export.store_start": "تجهيز التصدير",
  "export.store_preparing": "جارٍ تجهيز التصدير ({done} من {total})…",
  "export.store_failed": "تعذّر تجهيز التصدير. حاول مرة أخرى.",
  "collab.title": "الموافقة على وصول المتعاون",
  "collab.step_review": "مراجعة الطلب",
  "collab.step_access": "تحديد الوصول",
  "collab.step_confirm": "التأكيد",
  "collab.intro": "يطلب {partner} وصول متعاون إلى هذا المتجر.",
  "collab.message": "رسالته",
  "collab.permissions": "الصلاحيات المطلوبة ({n})",
  "collab.no_permissions": "لم تُطلب أي صلاحيات.",
  "collab.duration": "متى ينتهي الوصول؟",
  "collab.never": "يبقى الوصول حتى أزيله",
  "collab.days": "بعد {n} يومًا",
  "collab.custom": "في تاريخ محدد",
  "collab.date": "تاريخ الانتهاء",
  "collab.summary": "سيحصل {partner} على {n} صلاحية في هذا المتجر.",
  "collab.summary_until": "ينتهي الوصول تلقائيًا في {date}.",
  "collab.summary_forever": "يبقى الوصول حتى تزيله من المستخدمون والصلاحيات.",
  "collab.security_note": "قد يُطلب منك تأكيد هويتك قبل منح الوصول.",
  "collab.resumed": "تم تأكيد هويتك. امنح الوصول للإنهاء.",
  "collab.grant": "منح الوصول",
  "collab.granted": "أصبح لدى {partner} وصول متعاون.",
  "collab.decline_title": "رفض طلب {partner}؟",
  "collab.decline_body": "لن يحصل على وصول إلى هذا المتجر، ويمكنه إرسال طلب جديد لاحقًا.",
  "collab.declined": "تم رفض الطلب.",
  "users.remove_title": "إزالة {name}؟",
  "users.remove_body": "سيفقد الوصول إلى هذا المتجر فورًا.",

  "notif.store_emails": "الرسائل المرسلة إليك",
  "notif.log": "سجل الرسائل",
  "notif.type.trial_ending": "تذكيرات انتهاء الفترة التجريبية",
  "notif.type.trial_ended": "انتهاء الفترة التجريبية",
  "notif.type.collaborator_request": "طلبات التعاون",
  "notif.type.transfer_accepted": "قبول نقل المتجر",
  "notif.type.invoice_issued": "الفواتير للعملاء",
  "notif.type.shipping_update": "تحديثات الشحن للعملاء",
  "notif.type.out_for_delivery": "خرج للتوصيل (العملاء)",
  "notif.type.delivered": "تم التوصيل (العملاء)",
  "notif.status.queued": "في الانتظار",
  "notif.status.sent": "أُرسلت",
  "notif.status.delivered": "وصلت",
  "notif.status.bounced": "مرتدّة",
  "notif.status.complained": "أُبلغ عنها كرسالة مزعجة",
  "notif.status.failed": "فشلت",
  "notif.status.suppressed": "لم تُرسل (محظور)",

  "files.title": "الملفات",
  "files.upload": "رفع ملفات",
  "files.drop": "أفلت الملفات لرفعها",
  "files.storage": "مستخدم {used} من {quota}",
  "files.uploading": "جارٍ رفع {name}",
  "files.processing": "قيد المعالجة",
  "files.failed": "فشل",
  "files.delete_confirm": "حذف {name}؟ لا يمكن التراجع.",
  "files.in_use": "هذا الملف مستخدم ولا يمكن حذفه.",
  "files.empty": "ارفع الصور والفيديو والمستندات لاستخدامها في متجرك.",
  "files.alt": "النص البديل",
  "files.copy_link": "نسخ الرابط",
  "files.copied": "نُسخ الرابط",

  "activity.title": "سجل النشاط",
  "activity.empty": "لا يوجد نشاط بعد.",
  "activity.by": "بواسطة {actor}",
  "activity.load_more": "عرض المزيد",

  "partner.title": "لوحة الشريك",
  "partner.pending": "طلب انضمامك كشريك قيد المراجعة. يمكنك بالفعل بناء متاجر تطوير.",
  "partner.stores": "المتاجر",
  "partner.dev_store": "إنشاء متجر تطوير",
  "partner.request": "طلب الوصول إلى متجر",
  "partner.store_domain": "عنوان المتجر",
  "partner.permissions": "الصلاحيات",
  "partner.message": "رسالة إلى المالك",
  "partner.send_request": "إرسال الطلب",
  "partner.requests": "طلبات الوصول",
  "partner.transfers": "عمليات النقل",
  "partner.earnings": "الأرباح",
  "partner.earnings_soon": "تُدفع حصة الإيرادات عندما تشترك المتاجر التي أحلتها في خطط مدفوعة.",
  "partner.referral": "رمز الإحالة",

  "accept.transfer_title": "قبول المتجر",
  "accept.transfer_body": "عُرضت عليك ملكية متجر. بالقبول تصبح مالكه وتبدأ فترة تجريبية مجانية.",
  "accept.accept": "قبول",
  "accept.invite_title": "الانضمام إلى الفريق",
  "accept.invite_body": "اقبل الدعوة للانضمام إلى هذا الفريق.",
  "common.add": "إضافة",
  "richtext.link": "إدراج رابط",
  "richtext.insert_link": "إدراج",
  "richtext.link_url": "الرابط",
  "richtext.link_hint": "عنوان ويب (https://…) أو بريد (mailto:…) أو هاتف (tel:…) أو مسار في المتجر (/pages/…)",
  "content.metaobjects": "المحتوى المخصص",
  "content.manage_definitions": "إدارة التعريفات",
  "content.metaobjects_empty": "لا توجد أنواع محتوى بعد",
  "content.metaobjects_empty_body": "عرّف محتوى منظماً مثل جداول المقاسات أو الأسئلة الشائعة، ثم أضف الإدخالات هنا.",
  "content.col.definition": "التعريف",
  "content.col.entries": "الإدخالات",
  "settings.customer_privacy": "خصوصية العملاء",
  "settings.customer_privacy_hint": "طلبات بيانات العملاء: التصدير والمسح",
  "nav.metaobjects": "المحتوى المخصص",
  "nav.files": "الملفات",
  "nav.gift_cards": "بطاقات الهدايا",
  "nav.drafts": "الطلبات اليدوية",
  "nav.abandoned": "السلال المستردة",
};

export default ar;
